<template>
    <v-flex xs12>
        <h1 class="display-1">Gestión del arbol de menu</h1>
        <v-select :items="roles" v-model="rol" label="Seleccione rol" single-line :loading="loadingRoles"
                  item-value="id" item-text="display_name" @input="getAsigados"
        ></v-select>
        <v-card>
            <v-card-text>
                <v-list dense>
                    <template v-for="(item, i) in arbol">
                        <v-list-group v-if="item.children" v-model="item.model" no-action :prepend-icon="item.icon" expand>
                            <v-list-tile slot="activator" @click="">
                                <v-list-tile-content>
                                    <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                                    <v-list-tile-sub-title v-if="item.subtitle">{{ item.subtitle }}</v-list-tile-sub-title>
                                </v-list-tile-content>
                                <v-list-tile-action>
                                    <v-checkbox v-model="selected" :value="item.id"></v-checkbox>
                                </v-list-tile-action>
                            </v-list-tile>
                            <template v-for="(child, i) in item.children">
                                <v-list-group v-if="child.children" sub-group no-action v-model="child.model">
                                    <v-list-tile slot="activator">
                                        <v-list-tile-content>
                                            <v-list-tile-title>{{ child.title }}</v-list-tile-title>
                                            <v-list-tile-sub-title v-if="child.subtitle">{{ child.subtitle }}</v-list-tile-sub-title>
                                        </v-list-tile-content>
                                        <v-list-tile-action>
                                            <v-checkbox v-model="selected" :value="child.id"></v-checkbox>
                                        </v-list-tile-action>
                                    </v-list-tile>
                                    <template  v-for="(c, i) in child.children" @click="">
                                        <v-list-tile>
                                            <v-list-tile-action v-if="child.icon">
                                                <v-icon>{{ child.icon }}</v-icon>
                                            </v-list-tile-action>
                                            <v-list-tile-title>{{ c.title }}</v-list-tile-title>
                                            <v-list-tile-action>
                                                <v-checkbox v-model="selected" :value="c.id"></v-checkbox>
                                            </v-list-tile-action>
                                        </v-list-tile>
                                    </template>
                                </v-list-group>
                                <v-list-tile v-else>
                                    <v-list-tile-action v-if="child.icon">
                                        <v-icon>{{ child.icon }}</v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-content>
                                        <v-list-tile-title>{{ child.title }}</v-list-tile-title>
                                        <v-list-tile-sub-title v-if="child.subtitle">{{ child.subtitle }}</v-list-tile-sub-title>
                                    </v-list-tile-content>
                                    <v-list-tile-action>
                                        <v-checkbox v-model="selected" :value="child.id"></v-checkbox>
                                    </v-list-tile-action>
                                </v-list-tile>
                            </template>
                        </v-list-group>
                        <v-list-tile v-else @click="" exact>
                            <v-list-tile-action>
                                <v-icon>{{ item.icon }}</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title>
                                    {{ item.title }}
                                </v-list-tile-title>
                            </v-list-tile-content>
                            <v-list-tile-action>
                                <v-checkbox v-model="selected" :value="item.id"></v-checkbox>
                            </v-list-tile-action>
                        </v-list-tile>
                    </template>
                </v-list>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click.native="guardar" :loading="loading">guardar</v-btn>
            </v-card-actions>
        </v-card>
        <errores v-model="msj.mostrar" :datos="msj"></errores>
    </v-flex>
</template>
<script>
    import mixinRole from '../../mixins/auth/roles'
    import mixinMenu from '../../mixins/auth/menu'
    import errores from '../../components/Errores';

    export default {
        name: 'arbol',
        mixins: [mixinRole, mixinMenu],
        components: {errores},
        data() {
            return {
                loading: false,
                arbol: [],
                selected: [],
                roles: [],
                rol: '',
                loadingRoles: false,
                msj: {
                    mostrar: false,
                    txt: '',
                    tipo: ''
                }
            }
        },
        mounted() {
            this.getArbol();
            this.getRoles();
        },
        methods: {
            getAsigados() {
                this.menuRolesAsignados({role_id: this.rol},
                    r => {
                        this.selected = r;
                    }, err => {
                        console.log(err)
                    })
            },
            getRoles() {
                this.loadingRoles = true;
                this.rolesList(r => {
                    this.roles = r;
                    this.loadingRoles = false;
                }, err => {
                    console.log(err)
                    this.loadingRoles = false;
                })
            },
            getArbol() {
                this.$http.post('menu/arbol', {todo: true})
                    .then(r => {
                        this.arbol = r.data;
                    })
                    .catch(err => {
                        console.log(err)
                    })
            },
            guardar() {
                this.loading = true;
                this.menuAsignarRoles({role_id: this.rol, menu_id: this.selected},
                    r => {
                        this.msj = r;
                        this.loading = false;
                    }, err => {
                        this.msj = {
                            mostrar: true,
                            txt: 'Error al guardar',
                            tipo: 'error'
                        };
                        this.loading = false;
                        console.log(err)
                    })
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/pages/auth/arbol.vue